import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Footer from "./components/Footer";
import {BrowserRouter as AllRoutes , Routes, Route} from "react-router-dom"
import Singlecategory from "./components/Singlecategory";
import Category from "./components/Category";
import Notfound from "./components/Notfound";


function App() {
  return (
    <div>
      <AllRoutes>
        <Navbar/>
        <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/single/:id" element={<Singlecategory/>}/>
        <Route path="/home/single/:id" element={<Singlecategory/>}/>
        <Route path="/category" element={<Category/>}/>
        <Route path="*" element={<Notfound/>}/>
        
        </Routes>
        <Footer/>
      </AllRoutes>
      
    </div>
  );
}

export default App;